"use client";

import { DonutChart } from '@tremor/react';
import React from 'react'

export default function PieChart(props) {

  const valueFormatter = (number) => `${new Intl.NumberFormat("sv-se").format(number).toString()} AED`;

  return (
    <DonutChart
      valueFormatter={valueFormatter}
      {...props}
    />
  )
}
